// DynamicEditComponent.jsx
import React, { useState } from "react";
import axiosInstance from "../../../../utils/axiosConfig";

const DynamicEditComponent = ({ fields, data, onClose, onSave, apiEndpoint, rowKey }) => {
  const [formData, setFormData] = useState(
    fields.reduce((acc, field) => {
      acc[field.name] = data[field.name] || field.defaultValue || "";
      return acc;
    }, {})
  );

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSave = async () => {
    try {
      const response = await axiosInstance.put(`${apiEndpoint}/${data[rowKey]}`, formData);
      if (response.status === 200) {
        onSave({ ...data, ...formData });
        onClose();
      } else {
        console.error("Error saving data:", response.data);
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded shadow-lg w-full max-w-md mx-4">
        <h2 className="text-lg font-semibold mb-4">Edit {data.LocationName || "Item"}</h2>
        <form className="flex flex-col gap-4">
          {fields.map((field) => (
            <div key={field.name} className="flex flex-col">
              <label className="mb-1 text-sm font-medium">{field.label}</label>
              {field.type === "textarea" ? (
                <textarea
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  className="px-3 py-2 border rounded resize-none"
                  rows={field.rows || 3}
                />
              ) : field.type === "select" ? (
                <select
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  className="px-3 py-2 border rounded"
                >
                  {field.options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              ) : field.type === "checkbox" ? (
                <input
                  type="checkbox"
                  name={field.name}
                  checked={formData[field.name]}
                  onChange={handleInputChange}
                  className="h-5 w-5"
                />
              ) : (
                <input
                  type={field.type || "text"}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  className="px-3 py-2 border rounded"
                  placeholder={field.placeholder || ""}
                />
              )}
            </div>
          ))}
          <div className="flex flex-col sm:flex-row gap-4 mt-4">
            <button
              type="button"
              onClick={handleSave}
              className="w-full sm:flex-1 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 mb-2 sm:mb-0"
            >
              Save
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full sm:flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DynamicEditComponent;